import { create } from 'zustand';

const useLocalStates = create((set, get) => ({

  openClaimModal: false,
  // Actions
  setOpenClaimModal: (open) => set({ openClaimModal: open })
}));

export default useLocalStates;
